import React, { useEffect, useState } from 'react';

import { Player } from '@lottiefiles/react-lottie-player';
import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { LockAnimation } from '@common/assets';
import LockIcon from '@mui/icons-material/Lock';

const LottiePlayer = styled(Player)`
  width: 40px;
  height: 40px;
`;

const Container = styled(Box)`
  width: fit-content;
  background-color: #3169f6;
  border-radius: 50%;
  padding: 4px;
`;

const LockContainer = styled(Stack)`
  width: 48px;
  height: 48px;
  background-color: #3169f6;
  border-radius: 50%;
  color: white;
  justify-content: center;
  align-items: center;
`;

type Props = {
  lock: boolean;
};

export const LockUnlock = ({ lock }: Props) => {
  const [isLock, setIsLock] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLock(lock);
    }, 4000);

    return () => {
      clearTimeout(timeout);
    };
  }, [lock]);

  if (isLock) {
    return (
      <LockContainer>
        <LockIcon sx={{ fontSize: '28px' }} />
      </LockContainer>
    );
  }

  return (
    <Container>
      <LottiePlayer autoplay loop={false} keepLastFrame src={LockAnimation} />
    </Container>
  );
};
